import {classAdderBuilder} from '@smui/common/classAdderBuilder.js';
import Div from '@smui/common/Div.svelte';

export default classAdderBuilder({
  class: 'mdc-dialog__content',
  component: Div,
  contexts: {}
});